import { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useClickOutside } from "../../../shared/hookHelpers";
import IntentButton from "./IntentButton";

const IntentDropdown = ({ className = "", onUpdate, person: propPerson = null }) => {
  const selectPerson = useSelector((state) => state.personDetail.person);
  const person = propPerson || selectPerson;
  const ref = useRef();
  const [expanded, setExpanded] = useState(false);
  const closeMenu = useCallback(() => setExpanded(false), []);
  useClickOutside(ref, closeMenu, true);

  const intentOptions = person.meta?.intentOptions || person.meta?.intent_options;
  const leadType = person.data?.attributes?.leadType || person.data?.attributes?.lead_type;

  const currentLabel = intentOptions?.find(([, value]) => value === leadType)?.[0] || "Unknown";

  if (!person.data) return null;

  const updateKey = person.data?.attributes?.leadType !== undefined ? "leadType" : "lead_type";

  return (
    <div ref={ref} className={`tw-relative ${className}`}>
      <IntentButton isMenu label={currentLabel} onClick={() => setExpanded((exp) => !exp)} type={leadType} />
      {expanded && (
        <div className="tw-z-2 tw-absolute tw-w-[144px] tw-left-[50%] tw-translate-x-[-50%] tw-top-[100%] tw-p-[12px] tw-flex tw-flex-col tw-gap-[8px] tw-rounded-[8px] tw-bg-white tw-shadow-dropdown">
          {intentOptions?.map(([name, value]) => (
            <IntentButton
              key={value}
              label={name}
              type={value}
              onClick={() => {
                setExpanded(false);
                onUpdate(updateKey, value);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

IntentDropdown.propTypes = {
  className: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
  person: PropTypes.shape({}),
};

export default IntentDropdown;
